const API_BASE = '/api';

class ApiClient {
  constructor() {
    this.token = localStorage.getItem('token');
  }

  setToken(token) {
    this.token = token;
    if (token) {
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
    }
  }

  async request(endpoint, options = {}) {
    const url = `${API_BASE}${endpoint}`;
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
    };

    if (this.token) {
      headers['Authorization'] = `Bearer ${this.token}`;
    }

    const response = await fetch(url, {
      ...options,
      headers,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || data.message || 'Request failed');
    }

    return data;
  }

  // Auth
  login(username, password) {
    return this.request('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    });
  }

  register(username, email, password) {
    return this.request('/auth/register', {
      method: 'POST',
      body: JSON.stringify({ username, email, password }),
    });
  }

  getMe() {
    return this.request('/auth/me');
  }

  // Providers
  getProviders() {
    return this.request('/providers');
  }

  addProvider(provider) {
    return this.request('/providers', {
      method: 'POST',
      body: JSON.stringify(provider),
    });
  }

  updateProvider(id, provider) {
    return this.request(`/providers/${id}`, {
      method: 'PUT',
      body: JSON.stringify(provider),
    });
  }

  deleteProvider(id) {
    return this.request(`/providers/${id}`, {
      method: 'DELETE',
    });
  }

  resetProvider(id) {
    return this.request(`/providers/${id}/reset`, {
      method: 'POST',
    });
  }

  getProviderStatus() {
    return this.request('/providers/status');
  }

  // Stats
  getStats() {
    return this.request('/stats/overview');
  }

  getRecentRequests(limit = 50) {
    return this.request(`/stats/recent?limit=${limit}`);
  }

  // Model testing
  discoverModels(baseUrl, apiKey) {
    return this.request('/models/discover', {
      method: 'POST',
      body: JSON.stringify({ base_url: baseUrl, api_key: apiKey }),
    });
  }

  testAllModels(baseUrl, apiKey, modelIds = null, concurrency = 50) {
    const body = { base_url: baseUrl, api_key: apiKey, concurrency };
    if (modelIds) body.model_ids = modelIds;
    return this.request('/models/test-all', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  testSingleModel(baseUrl, apiKey, modelId) {
    return this.request('/models/test-single', {
      method: 'POST',
      body: JSON.stringify({ base_url: baseUrl, api_key: apiKey, model_id: modelId }),
    });
  }

  testSavedProvider(providerId) {
    return this.request(`/models/test-saved/${providerId}`, {
      method: 'POST',
    });
  }
}

export const api = new ApiClient();
export default api;
